const selectPlayableChallengeCounts = games => games.reduce((sum, game) => ({
  total: sum.total + game.totalChallenges,
  remaining: sum.remaining + game.remaining,
}), { total: 0, remaining: 0 });


export default selectPlayableChallengeCounts;
